import React, { useEffect, useState } from 'react'
import { Box, Button, Link } from '@mui/material'
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap'
import Grid from '@mui/material/Grid'
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from 'react-icons/io'
import {
  Paging,
  PrevButton,
  NextButton,
} from '../ContainerOrder/images/ContainerImagesEditModalImage.styles'
import { t } from 'i18next'
import { ContainerImagesEditModal } from '../../organisms/ContainerOrder/Images/ContainerImagesEditModal'
import { IImage } from '~/src/repositories/Container/schema/IImage'

export const ItemPhoto: React.FC<{
  images: IImage[]
}> = ({ images }): JSX.Element => {
  const [mainImageId, setMainImageId] = useState<number>(images[0].id)
  const [indexImage, setIndexImage] = useState<number>(0)
  const [showImages, setShowImages] = useState<IImage[]>([])
  const [mainImage, setMainImage] = useState<IImage>(images[0])

  // コンテナ画像
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false)

  /**
   * 画像のページネーション制御
   */
  const handleNextImage = () => {
    setIndexImage(indexImage + 1)
  }
  const handlePrevImage = () => {
    setIndexImage(indexImage - 1)
  }
  const imageCount = images.length
  const pageCount = Math.floor(imageCount / 12) === 0 ? 1 : Math.floor(imageCount / 12) + 1
  useEffect(() => {
    const startIndex = indexImage * 12
    const endIndex = startIndex + 12

    const newShowImages = images
      .map((image: IImage, index: number) => {
        if (startIndex <= index && index < endIndex) {
          return image
        }
      })
      .filter((image: IImage | undefined) => image) as IImage[]

    setShowImages(newShowImages)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [indexImage])

  /**
   * メイン画像の切り替え
   */
  useEffect(() => {
    const changeMainImage = images.find((image: IImage) => image.id === mainImageId) as IImage
    setMainImage(changeMainImage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainImageId])

  return (
    <>
      <Box mb={1.5} position={'relative'} zIndex={1}>
        <img
          src={mainImage.file.url}
          alt={mainImage.file.filename}
          loading="lazy"
          width={'334px'}
          height={'263.07px'}
          style={{ margin: 'auto', maxWidth: 'full' }}
        />
        <Link
          sx={{
            backgroundColor: 'white',
            color: '#000',
            position: 'absolute',
            bottom: '8px',
            right: '8px',
            padding: '6px',
            marginBottom: '8px',
            paddingBottom: '0px',
          }}
          target={'_blank'}
          href={mainImage.file.url}
        >
          <ZoomOutMapIcon />
        </Link>
      </Box>

      <Box overflow="auto">
        <Grid gap={'6px'} sx={{ display: 'grid', gridTemplateColumns: 'repeat(6,1fr)' }}>
          {showImages.map((image, index) => {
            return (
              <Grid item key={index} onClick={() => setMainImageId(image.id)} width={'100%'}>
                <Box sx={{ backgroundColor: '#F8F9FA', height: 'auto' }}>
                  <img
                    alt={image.file.filename}
                    src={image.file.url}
                    style={{
                      width: '50.67px',
                      height: 'auto',
                      margin: 'auto',
                      maxWidth: 'full',
                      minWidth: 'full',
                      objectFit: 'cover',
                    }}
                  />
                </Box>
              </Grid>
            )
          })}
        </Grid>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '32px' }}>
        <Box sx={{ display: 'flex' }}>
          <Button
            sx={{ marginTop: '8px' }}
            variant="outlined"
            size="small"
            onClick={() => setIsEditModalOpen(true)}
          >{`${t('container_order_detail.edit')}`}</Button>
          {isEditModalOpen && (
            <ContainerImagesEditModal
              containerImages={images}
              isOpen={isEditModalOpen}
              handleClose={() => setIsEditModalOpen(false)}
            />
          )}
        </Box>

        <Paging sx={{ display: 'flex', marginTop: '8px' }}>
          <PrevButton disabled={indexImage === 0} onClick={handlePrevImage}>
            <IoIosArrowDropleftCircle size={24} color={'#222'} />
          </PrevButton>
          <Box sx={{ display: 'table' }}>
            <Box sx={{ display: 'table-cell', verticalAlign: 'middle' }}>
              {indexImage + 1}/{pageCount}
            </Box>
          </Box>
          <NextButton disabled={indexImage === pageCount - 1} onClick={handleNextImage}>
            <IoIosArrowDroprightCircle size={24} color={'#222'} />
          </NextButton>
        </Paging>
      </Box>
    </>
  )
}
